// extracted by mini-css-extract-plugin
module.exports = {"titleBar":"_1yFXJFzKF3azSaMsZmarN3"};